// Local Shipping Service - No backend required
import localAuthService from './localAuthService';

class LocalShippingService {
  constructor() {
    this.shipments = this.loadShipments();
    this.quotes = this.loadQuotes();
    this.templates = this.loadTemplates();
    this.carriers = this.loadCarriers();
  }

  // Load shipments from localStorage
  loadShipments() {
    const shipments = localStorage.getItem('silva_shipments');
    return shipments ? JSON.parse(shipments) : [
      {
        id: '1',
        userId: '2',
        trackingNumber: 'SILVA123456789',
        status: 'in_transit',
        origin: {
          name: 'Juan Pérez',
          address: 'Calle Principal 123',
          city: 'Ciudad de México',
          state: 'CDMX',
          country: 'México',
          zipCode: '06000',
          phone: '+52 55 1234 5678'
        },
        destination: {
          name: 'María García',
          address: 'Av. Reforma 456',
          city: 'Guadalajara',
          state: 'Jalisco',
          country: 'México',
          zipCode: '44100',
          phone: '+52 33 9876 5432'
        },
        package: {
          weight: 2.5,
          length: 30,
          width: 20,
          height: 15,
          description: 'Productos electrónicos'
        },
        carrier: 'fedex',
        service: 'express',
        cost: 150.00,
        currency: 'USD',
        createdAt: new Date(Date.now() - 86400000).toISOString(),
        updatedAt: new Date(Date.now() - 86400000).toISOString(),
        estimatedDelivery: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString()
      },
      {
        id: '2',
        userId: '2',
        trackingNumber: 'SILVA987654321',
        status: 'delivered',
        origin: {
          name: 'Carlos López',
          address: 'Plaza Mayor 789',
          city: 'Monterrey',
          state: 'Nuevo León',
          country: 'México',
          zipCode: '64000',
          phone: '+52 81 5555 1234'
        },
        destination: {
          name: 'Ana Rodríguez',
          address: 'Calle Juárez 321',
          city: 'Puebla',
          state: 'Puebla',
          country: 'México',
          zipCode: '72000',
          phone: '+52 222 3333 4444'
        },
        package: {
          weight: 1.8,
          length: 25,
          width: 18,
          height: 12,
          description: 'Ropa y accesorios'
        },
        carrier: 'ups',
        service: 'ground',
        cost: 85.00,
        currency: 'USD',
        createdAt: new Date(Date.now() - 172800000).toISOString(),
        updatedAt: new Date(Date.now() - 86400000).toISOString(),
        deliveredAt: new Date(Date.now() - 86400000).toISOString()
      }
    ];
  }

  // Save shipments to localStorage
  saveShipments() {
    localStorage.setItem('silva_shipments', JSON.stringify(this.shipments));
  }

  // Load quotes from localStorage
  loadQuotes() {
    const quotes = localStorage.getItem('silva_quotes');
    return quotes ? JSON.parse(quotes) : [
      {
        id: '1',
        userId: '2',
        origin: {
          city: 'Ciudad de México',
          state: 'CDMX',
          country: 'México',
          zipCode: '06000'
        },
        destination: {
          city: 'Guadalajara',
          state: 'Jalisco',
          country: 'México',
          zipCode: '44100'
        },
        package: {
          weight: 2.5,
          length: 30,
          width: 20,
          height: 15
        },
        options: [
          {
            carrier: 'fedex',
            service: 'express',
            cost: 150.00,
            deliveryTime: '1-2 días'
          },
          {
            carrier: 'ups',
            service: 'ground',
            cost: 95.00,
            deliveryTime: '3-5 días'
          },
          {
            carrier: 'dhl',
            service: 'standard',
            cost: 120.00,
            deliveryTime: '2-3 días'
          }
        ],
        createdAt: new Date().toISOString()
      }
    ];
  }

  // Save quotes to localStorage
  saveQuotes() {
    localStorage.setItem('silva_quotes', JSON.stringify(this.quotes));
  }

  // Load templates from localStorage
  loadTemplates() {
    const templates = localStorage.getItem('silva_shipping_templates');
    return templates ? JSON.parse(templates) : [
      {
        id: '1',
        userId: '2',
        name: 'Envío Estándar',
        origin: {
          name: 'Mi Empresa',
          address: 'Calle Comercial 123',
          city: 'Ciudad de México',
          state: 'CDMX',
          country: 'México',
          zipCode: '06000',
          phone: '+52 55 1234 5678'
        },
        packageDefaults: {
          weight: 1.0,
          length: 20,
          width: 15,
          height: 10
        },
        createdAt: new Date().toISOString()
      }
    ];
  }

  // Save templates to localStorage
  saveTemplates() {
    localStorage.setItem('silva_shipping_templates', JSON.stringify(this.templates));
  }

  // Load carriers from localStorage
  loadCarriers() {
    const carriers = localStorage.getItem('silva_carriers');
    return carriers ? JSON.parse(carriers) : [
      {
        id: 'fedex',
        name: 'FedEx',
        logo: '/fedex-logo.png',
        services: [
          { id: 'express', name: 'Express', deliveryTime: '1-2 días' },
          { id: 'ground', name: 'Ground', deliveryTime: '3-5 días' }
        ]
      },
      {
        id: 'ups',
        name: 'UPS',
        logo: '/ups-logo.png',
        services: [
          { id: 'express', name: 'Express', deliveryTime: '1-2 días' },
          { id: 'ground', name: 'Ground', deliveryTime: '3-5 días' }
        ]
      },
      {
        id: 'dhl',
        name: 'DHL',
        logo: '/dhl-logo.png',
        services: [
          { id: 'express', name: 'Express', deliveryTime: '1-2 días' },
          { id: 'standard', name: 'Standard', deliveryTime: '2-3 días' }
        ]
      }
    ];
  }

  // Save carriers to localStorage
  saveCarriers() {
    localStorage.setItem('silva_carriers', JSON.stringify(this.carriers));
  }

  // Get current user
  async getCurrentUser() {
    return await localAuthService.getCurrentUser();
  }

  // Get quote
  async getQuote(quoteData) {
    const user = await this.getCurrentUser();
    if (!user) {
      throw new Error('Usuario no autenticado');
    }

    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 1000));

    const options = [
      {
        carrier: 'fedex',
        service: 'express',
        cost: Math.round((Math.random() * 100 + 50) * 100) / 100,
        deliveryTime: '1-2 días'
      },
      {
        carrier: 'ups',
        service: 'ground',
        cost: Math.round((Math.random() * 80 + 40) * 100) / 100,
        deliveryTime: '3-5 días'
      },
      {
        carrier: 'dhl',
        service: 'standard',
        cost: Math.round((Math.random() * 90 + 45) * 100) / 100,
        deliveryTime: '2-3 días'
      }
    ];

    const quote = {
      id: Date.now().toString(),
      userId: user.id,
      origin: quoteData.origin,
      destination: quoteData.destination,
      package: quoteData.package,
      options,
      createdAt: new Date().toISOString()
    };

    this.quotes.push(quote);
    this.saveQuotes();

    return {
      success: true,
      quote,
      message: 'Cotización generada exitosamente'
    };
  }

  // Create shipment
  async createShipment(shipmentData) {
    const user = await this.getCurrentUser();
    if (!user) {
      throw new Error('Usuario no autenticado');
    }

    const trackingNumber = `SILVA${Date.now()}`;
    const estimatedDelivery = new Date();
    estimatedDelivery.setDate(estimatedDelivery.getDate() + 
      (shipmentData.carrier === 'fedex' && shipmentData.service === 'express' ? 2 : 5));

    const shipment = {
      id: Date.now().toString(),
      userId: user.id,
      trackingNumber,
      status: 'pending',
      origin: shipmentData.origin,
      destination: shipmentData.destination,
      package: shipmentData.package,
      carrier: shipmentData.carrier,
      service: shipmentData.service,
      cost: shipmentData.cost,
      currency: shipmentData.currency || 'USD',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      estimatedDelivery: estimatedDelivery.toISOString()
    };

    this.shipments.push(shipment);
    this.saveShipments();

    return {
      success: true,
      shipment,
      message: 'Envío creado exitosamente'
    };
  }

  // Get shipments
  async getShipments(filters = {}) {
    const user = await this.getCurrentUser();
    if (!user) {
      throw new Error('Usuario no autenticado');
    }

    let shipments = this.shipments.filter(s => s.userId === user.id);

    // Apply filters
    if (filters.status) {
      shipments = shipments.filter(s => s.status === filters.status);
    }

    if (filters.carrier) {
      shipments = shipments.filter(s => s.carrier === filters.carrier);
    }

    if (filters.startDate) {
      shipments = shipments.filter(s => new Date(s.createdAt) >= new Date(filters.startDate));
    }

    if (filters.endDate) {
      shipments = shipments.filter(s => new Date(s.createdAt) <= new Date(filters.endDate));
    }

    // Sort by date (newest first)
    shipments.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    return shipments;
  }

  // Get shipment by ID
  async getShipment(shipmentId) {
    const user = await this.getCurrentUser();
    if (!user) {
      throw new Error('Usuario no autenticado');
    }

    const shipment = this.shipments.find(
      s => s.id === shipmentId && s.userId === user.id
    );

    if (!shipment) {
      throw new Error('Envío no encontrado');
    }

    return shipment;
  }

  // Track shipment
  async trackShipment(trackingNumber) {
    const user = await this.getCurrentUser();
    if (!user) {
      throw new Error('Usuario no autenticado');
    }

    const shipment = this.shipments.find(
      s => s.trackingNumber === trackingNumber && s.userId === user.id
    );

    if (!shipment) {
      throw new Error('Envío no encontrado');
    }

    // Generate tracking events based on status
    const trackingEvents = this.generateTrackingEvents(shipment);

    return {
      success: true,
      shipment,
      trackingEvents,
      message: 'Información de seguimiento obtenida'
    };
  }

  // Generate tracking events
  generateTrackingEvents(shipment) {
    const events = [
      {
        id: '1',
        status: 'created',
        description: 'Envío creado',
        location: shipment.origin.city,
        timestamp: shipment.createdAt
      }
    ];

    if (shipment.status === 'in_transit' || shipment.status === 'delivered') {
      events.push({
        id: '2',
        status: 'picked_up',
        description: 'Envío recogido',
        location: shipment.origin.city,
        timestamp: new Date(new Date(shipment.createdAt).getTime() + 2 * 60 * 60 * 1000).toISOString()
      });

      events.push({
        id: '3',
        status: 'in_transit',
        description: 'En tránsito',
        location: 'Centro de distribución',
        timestamp: new Date(new Date(shipment.createdAt).getTime() + 24 * 60 * 60 * 1000).toISOString()
      });
    }

    if (shipment.status === 'delivered') {
      events.push({
        id: '4',
        status: 'out_for_delivery',
        description: 'En camino para entrega',
        location: shipment.destination.city,
        timestamp: new Date(new Date(shipment.createdAt).getTime() + 48 * 60 * 60 * 1000).toISOString()
      });

      events.push({
        id: '5',
        status: 'delivered',
        description: 'Entregado',
        location: shipment.destination.city,
        timestamp: shipment.deliveredAt || new Date().toISOString()
      });
    }

    return events.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
  }

  // Update shipment status
  async updateShipmentStatus(shipmentId, status) {
    const user = await this.getCurrentUser();
    if (!user) {
      throw new Error('Usuario no autenticado');
    }

    const shipmentIndex = this.shipments.findIndex(
      s => s.id === shipmentId && s.userId === user.id
    );

    if (shipmentIndex === -1) {
      throw new Error('Envío no encontrado');
    }

    this.shipments[shipmentIndex].status = status;
    this.shipments[shipmentIndex].updatedAt = new Date().toISOString();

    if (status === 'delivered') {
      this.shipments[shipmentIndex].deliveredAt = new Date().toISOString();
    }

    this.saveShipments();

    return {
      success: true,
      shipment: this.shipments[shipmentIndex],
      message: 'Estado del envío actualizado'
    };
  }

  // Get shipping templates
  async getTemplates() {
    const user = await this.getCurrentUser();
    if (!user) {
      throw new Error('Usuario no autenticado');
    }

    return this.templates.filter(t => t.userId === user.id);
  }

  // Create template
  async createTemplate(templateData) {
    const user = await this.getCurrentUser();
    if (!user) {
      throw new Error('Usuario no autenticado');
    }

    const template = {
      id: Date.now().toString(),
      userId: user.id,
      ...templateData,
      createdAt: new Date().toISOString()
    };

    this.templates.push(template);
    this.saveTemplates();

    return {
      success: true,
      template,
      message: 'Plantilla creada exitosamente'
    };
  }

  // Update template
  async updateTemplate(templateId, templateData) {
    const user = await this.getCurrentUser();
    if (!user) {
      throw new Error('Usuario no autenticado');
    }

    const templateIndex = this.templates.findIndex(
      t => t.id === templateId && t.userId === user.id
    );

    if (templateIndex === -1) {
      throw new Error('Plantilla no encontrada');
    }

    this.templates[templateIndex] = {
      ...this.templates[templateIndex],
      ...templateData,
      updatedAt: new Date().toISOString()
    };

    this.saveTemplates();

    return {
      success: true,
      template: this.templates[templateIndex],
      message: 'Plantilla actualizada exitosamente'
    };
  }

  // Delete template
  async deleteTemplate(templateId) {
    const user = await this.getCurrentUser();
    if (!user) {
      throw new Error('Usuario no autenticado');
    }

    const templateIndex = this.templates.findIndex(
      t => t.id === templateId && t.userId === user.id
    );

    if (templateIndex === -1) {
      throw new Error('Plantilla no encontrada');
    }

    this.templates.splice(templateIndex, 1);
    this.saveTemplates();

    return {
      success: true,
      message: 'Plantilla eliminada exitosamente'
    };
  }

  // Get carriers
  async getCarriers() {
    return this.carriers;
  }

  // Generate shipping label
  async generateLabel(shipmentId) {
    const shipment = await this.getShipment(shipmentId);
    
    // Simulate label generation
    const label = {
      id: Date.now().toString(),
      shipmentId: shipment.id,
      trackingNumber: shipment.trackingNumber,
      carrier: shipment.carrier,
      service: shipment.service,
      origin: shipment.origin,
      destination: shipment.destination,
      package: shipment.package,
      barcode: `SILVA${shipment.trackingNumber}`,
      generatedAt: new Date().toISOString()
    };

    return {
      success: true,
      label,
      message: 'Etiqueta generada exitosamente'
    };
  }

  // Bulk create shipments
  async bulkCreateShipments(shipmentsData) {
    const user = await this.getCurrentUser();
    if (!user) {
      throw new Error('Usuario no autenticado');
    }

    const createdShipments = [];

    for (const shipmentData of shipmentsData) {
      const trackingNumber = `SILVA${Date.now()}-${Math.random().toString(36).substr(2, 5)}`;
      const estimatedDelivery = new Date();
      estimatedDelivery.setDate(estimatedDelivery.getDate() + 
        (shipmentData.carrier === 'fedex' && shipmentData.service === 'express' ? 2 : 5));

      const shipment = {
        id: Date.now().toString() + Math.random().toString(36).substr(2, 5),
        userId: user.id,
        trackingNumber,
        status: 'pending',
        origin: shipmentData.origin,
        destination: shipmentData.destination,
        package: shipmentData.package,
        carrier: shipmentData.carrier,
        service: shipmentData.service,
        cost: shipmentData.cost,
        currency: shipmentData.currency || 'USD',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        estimatedDelivery: estimatedDelivery.toISOString()
      };

      this.shipments.push(shipment);
      createdShipments.push(shipment);
    }

    this.saveShipments();

    return {
      success: true,
      shipments: createdShipments,
      message: `${createdShipments.length} envíos creados exitosamente`
    };
  }

  // Get shipping analytics
  async getShippingAnalytics() {
    const user = await this.getCurrentUser();
    if (!user) {
      throw new Error('Usuario no autenticado');
    }

    const userShipments = this.shipments.filter(s => s.userId === user.id);
    const now = new Date();
    const thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);

    const recentShipments = userShipments.filter(
      s => new Date(s.createdAt) >= thirtyDaysAgo
    );

    const totalShipments = recentShipments.length;
    const totalCost = recentShipments.reduce((sum, s) => sum + s.cost, 0);
    const deliveredShipments = recentShipments.filter(s => s.status === 'delivered').length;
    const inTransitShipments = recentShipments.filter(s => s.status === 'in_transit').length;

    const carriers = recentShipments.reduce((acc, s) => {
      acc[s.carrier] = (acc[s.carrier] || 0) + 1;
      return acc;
    }, {});

    return {
      totalShipments,
      totalCost,
      deliveredShipments,
      inTransitShipments,
      deliveryRate: totalShipments > 0 ? (deliveredShipments / totalShipments) * 100 : 0,
      carriers,
      averageCost: totalShipments > 0 ? totalCost / totalShipments : 0
    };
  }
}

// Create singleton instance
const localShippingService = new LocalShippingService();

export default localShippingService; 